import React from 'react';
import styled, { css } from 'styled-components';
import type { ThemeProps } from 'styled-components';
import type { SystemColorType, ThemeType } from '../../../util/types';
import { getPolishedColors } from '../../../util/styled';
import { PROGRESSIONS_MAX_NUM } from '../../../util/vars';
import classNames from 'classnames';
import { APP_THEME } from '../../../styles/theme/styled/theme';

type Props = {
  value: number
  active?: boolean
};

const Progressions = ({ value, active = true }: Props): JSX.Element => {
  return (
    <div className={'bg-white inline-block'}>
      <ProgressionsWrapper
        className={`p-sm text-gray-700 ${classNames({ 'text-black': active, 'font-bold': active })}`}
        $value={value}
        $active={active}
      >
        {value}
      </ProgressionsWrapper>
    </div>
  );
};

const getWrapperColor = (props: ThemeProps<ThemeType> & { $value: number, $active: boolean }) => {

  let color: SystemColorType = 'error';

  if (props.$value === PROGRESSIONS_MAX_NUM) {
    color = 'success';
  } else if (props.$value !== 0) {
    color = 'warning';
  }

  const colors = getPolishedColors({ theme: props.theme, $color: color });

  return css`
    background: ${colors.light.color};
    color: ${props.$active ? colors.light.readable : APP_THEME.colors.muted};
  `;
};

const ProgressionsWrapper = styled('div')<{ $value: number, $active: boolean }>`
  ${(props) => getWrapperColor(props)}
`;

export default Progressions;
